// SUMMARY: Product feature flags. Flip a flag here to enable/disable a capability across the whole app
// without deleting its implementation — the code stays in place for a later re-enable.

// Image generation (in-chat "/image" + the public /v1/images API) is temporarily disabled. The pipeline,
// models, usage tracking and admin analytics code all remain; this flag just removes it from every
// user-facing surface (chat, plans, landing, docs, dashboard limits, flow graph). Set to `true` to restore.
export const IMAGE_GENERATION_ENABLED = false

// On-demand PDF document generation in chat ("create a PDF report about X", "/pdf ..."). When off, every
// message is treated as a normal text/search turn. The pipeline (intent, generation, PDF render, storage,
// download route, usage tracking) all remain in place; this flag just gates the chat-route branch.
export const DOCUMENT_GENERATION_ENABLED = true

// Project workspaces (topic-scoped chats + RAG context files + tables/calendar/todos/notes with in-chat
// AI actions). When off, the sidebar entry, routes and chat-route project branches are all hidden while
// the implementation stays in place.
export const PROJECTS_ENABLED = true

// Full-data table analysis: when a spreadsheet (xlsx/csv) is attached and the user asks to work on it, the
// turn re-reads the FULL persisted workbook and answers by running model-written JS over ALL rows in the
// isolated sandbox (not the truncated text view), and can return a downloadable modified file. Depends on the
// isolated-vm sandbox (the analyze turn makes model-written code the primary table interface), so it must
// stay OFF on any runtime where that boundary is not in place.
export const TABLE_ANALYSIS_ENABLED = true

// Canvas: infinite Excalidraw whiteboards with AI generation/editing, PDF attachments, public share links and
// live YJS collaboration. When off, the sidebar entry, the project Canvas tab and the routes are hidden; the
// implementation (and the separate collab server) stay in place. Live collaboration additionally needs
// NEXT_PUBLIC_COLLAB_WS_URL and a running collab server - without them a canvas still works, just solo.
export const CANVAS_ENABLED = true

// AI-generated follow-up suggestions under the latest answer ("what to ask next"). When off, the client
// never asks for them and the route short-circuits, so the extra LLM call after every turn is not spent.
// The generator (src/lib/ai/suggestions.ts), its route, trace step and usage tracking all stay in place.
export const CHAT_SUGGESTIONS_ENABLED = false

// The landing page's "Available Models" catalog section. Hidden while the product is presented by what it
// DOES rather than which models it runs on; the section, its i18n and the model catalog all stay in place.
export const LANDING_MODELS_SECTION_ENABLED = false
